<template>
    <v-container id="filters-dialog">
        <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->

        <v-dialog v-model="dialog" scrollable max-width="1200px" :fullscreen="$vuetify.breakpoint.mobile">

            <v-card max-height="900px" class="backdrop dialog-card">
                <v-overlay absolute :value="overlay_loading">
                    <v-progress-circular indeterminate :size="80" :width="7"
                                         color="secondary"></v-progress-circular>
                </v-overlay>


                <v-card-title class="backdrop lighten-1 dialog-title">
                    <span class="text-h5">APPLY SEARCH FILTERS</span>
                </v-card-title>
                <v-card-text class="backdrop pa-0 white--text">
                    <v-container>

                        <v-form v-model="valid" ref="form">

                            <!--SELECTORS:-->
                            <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">

                                <div class="text-h6 mb-2"> SELECTORS : </div>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select :items="['ASSIGNED', 'OPEN', 'CLOSED', 'PENDING', 'SUBMITTED']" v-model="field_filters.status"
                                                  label="STATUS" placeholder="Select a status" maxlength="60">

                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select :items="user_records" item-text="proper_name" item-value="proper_name" v-model="field_filters.assigned"
                                                  label="DETECTIVE/OFFICER" placeholder="Select a detective/officer" maxlength="60">

                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select :items="['YES', 'NO', 'MAIT']" v-model="field_filters.priority"
                                                  label="PRIORITY" placeholder="YES/NO" maxlength="60">

                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select :items="['YES', 'NO']" v-model="field_filters.deleted"
                                                  label="DELETED" placeholder="Select Yes/No" maxlength="60">

                                        </v-select>
                                    </v-col>
                                </v-row>

                            </div>

                            <!--DATE:-->
                            <div class="ma-2"></div>
                            <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">

                                <div class="text-h6 mb-2"> DATES : </div>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field v-model="field_filters.sus_DOB" type="date" label="SUSPECT DOB"> </v-text-field>
                                    </v-col>

                                </v-row>

                                <v-row>
                                    <v-col cols="6" sm="6" md="6">
                                        <v-text-field v-model="field_filters.incident_date_start" type="date" label="INCIDENT START DATE" :rules="[field_rules.incident_date_rules]"> </v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="6">
                                        <v-text-field v-model="field_filters.incident_date_end" type="date" label="INCIDENT END DATE" :rules="[field_rules.incident_date_rules]"> </v-text-field>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col cols="6" sm="6" md="6">
                                        <v-text-field v-model="field_filters.modified_date_start" type="date" label="LAST MODIFIED START DATE" :rules="[field_rules.modified_date_rules]"> </v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="6">
                                        <v-text-field v-model="field_filters.modified_date_end" type="date" label="LAST MODIFIED END DATE" :rules="[field_rules.modified_date_rules]"> </v-text-field>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col cols="6" sm="6" md="6">
                                        <v-text-field v-model="field_filters.assigned_date_start" type="date" label="ASSIGNED START DATE" :rules="[field_rules.assigned_date_rules]"> </v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="6">
                                        <v-text-field v-model="field_filters.assigned_date_end" type="date" label="ASSIGNED END DATE" :rules="[field_rules.assigned_date_rules]"> </v-text-field>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col cols="6" sm="6" md="6">
                                        <v-text-field v-model="field_filters.closed_date_start" type="date" label="CLOSED START DATE" :rules="[field_rules.closed_date_rules]"> </v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="6">
                                        <v-text-field v-model="field_filters.closed_date_end" type="date" label="CLOSED END DATE" :rules="[field_rules.closed_date_rules]"> </v-text-field>
                                    </v-col>

                                </v-row>

                            </div>


                        </v-form>

                    </v-container>
                    <!--<small class="mx-4">*indicates required fields</small>-->
                </v-card-text>

                <v-card-actions class="backdrop lighten-1 border-card">
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" class="black--text"
                           @click="resetFilters">
                        Reset
                    </v-btn>
                    <v-btn color="secondary" class="black--text" :disabled="!valid"
                           @click="closeDialog">
                        Close
                    </v-btn>
                    <v-btn color="secondary" class="black--text" :disabled="!valid"
                           @click="applyFilters">
                        Apply
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>

    </v-container>
</template>

<style lang="scss" scoped>
    @import "../scss/site.scss";

    .dialog-card {
        box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
    }

    .dialog-title {
        margin-bottom: 2px;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
    }

    .custom-divider {
        height: 2px;
        background-color: black;
    }

    .border-card {
        margin: 2px;
    }
</style>

<script>
    /* eslint-disable */
    import { bus_common } from "../mixins/bus_common";
    export default {
        name: "filters-dialog",
        mixins: [bus_common],
        props: ["field_filters"],
        data() {
            return {
                dialog: true,
                overlay_loading: false,
                valid: false,
                field_rules: {
                    required: value => !!value || 'This field is required',
                    min: v => v.length >= 8 || 'Min 8 characters',
                    max25: v => v.length <= 60 || 'Max 60 characters',
                    email: value => {
                        const pattern = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                        return pattern.test(value) || 'Please provide a valid email address'
                    },
                    min_phone: v => v.length >= 14 || 'Please enter a complete phone number',
                    phone: value => {
                        const pattern = /^\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^\d{10}$|^1\s\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^(1\s?)?\(\d{3}\)(\s|\-)?\d{3}\-\d{4}$/;
                        return pattern.test(value) || 'Please provide a valid phone number'
                    },
                    filerequired: value => !!value || 'A signature image is required',
                    incident_date_rules: value => {
                        var bool = false;
                        if (this.field_filters.incident_date_start == "" && this.field_filters.incident_date_end == "") {
                            bool = true;
                        }
                        else if (this.field_filters.incident_date_start != "" && this.field_filters.incident_date_end != "") {
                            bool = true;
                        }
                        else {
                            bool = false;
                        }
                        return bool || 'A valid date range must be entered using both fields'
                    },
                    modified_date_rules: value => {
                        var bool = false;
                        if (this.field_filters.modified_date_start == "" && this.field_filters.modified_date_end == "") {
                            bool = true;
                        }
                        else if (this.field_filters.modified_date_start != "" && this.field_filters.modified_date_end != "") {
                            bool = true;
                        }
                        else {
                            bool = false;
                        }
                        return bool || 'A valid date range must be entered using both fields'
                    },
                    assigned_date_rules: value => {
                        var bool = false;
                        if (this.field_filters.assigned_date_start == "" && this.field_filters.assigned_date_end == "") {
                            bool = true;
                        }
                        else if (this.field_filters.assigned_date_start != "" && this.field_filters.assigned_date_end != "") {
                            bool = true;
                        }
                        else {
                            bool = false;
                        }
                        return bool || 'A valid date range must be entered using both fields'
                    },
                    closed_date_rules: value => {
                        var bool = false;
                        if (this.field_filters.closed_date_start == "" && this.field_filters.closed_date_end == "") {
                            bool = true;
                        }
                        else if (this.field_filters.closed_date_start != "" && this.field_filters.closed_date_end != "") {
                            bool = true;
                        }
                        else {
                            bool = false;
                        }
                        return bool || 'A valid date range must be entered using both fields'
                    },

                },
                user_records: [],
                noneuser: {
                    hitnrun_usersId: 0,
                    email_user: "",
                    proper_name: "None",
                    title: "",
                    phone: "",
                    file: null,
                    file_sig_image: "",
                    s_del: "f",
                    s_user: "",
                    s_createuser: "",
                    s_createdate: "1900-01-01",
                    s_date: "1900-01-01"
                }
            };
        },
        methods: {
            closeDialog() {
                this.dialog = false;
                setTimeout(() => {
                    this.$emit('closeDialog');
                }, 300)

            },
            resetFilters() {
                this.$emit("resetFilters");
                this.generate_filter_text();
            },
            async init() {
                this.overlay_loading = true;
                await this.getUserData();
                this.overlay_loading = false;
            },
            async getUserData() {
                let form = {
                    page: 1,
                    pageSize: -1,
                    sortBy: ["proper_name"],
                    sortDesc: [false]
                };

                await this.$axios.post('api/hitnrunuser/getUsers', form)
                    .then(response => {
                        this.user_records = response.data.lst_users;
                        this.user_records.unshift(this.noneuser);
                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });
            },
            generate_filter_text() {
                this.filters_active_text = []

                if (this.field_filters.status != "") {
                    let filter_text = { title: "STATUS", value: this.field_filters.status }
                    this.filters_active_text.push(filter_text)
                }

                if (this.field_filters.deleted != "NO") {
                    let filter_text = { title: "DELETED", value: this.field_filters.deleted }
                    this.filters_active_text.push(filter_text)
                }

                if (this.field_filters.priority != "") {
                    let filter_text = { title: "PRIORITY", value: this.field_filters.priority }
                    this.filters_active_text.push(filter_text)
                }

                if (this.field_filters.assigned != "") {
                    let filter_text = { title: "DET/OF", value: this.field_filters.assigned }
                    this.filters_active_text.push(filter_text)
                }

                if (this.field_filters.sus_DOB != "") {
                    let filter_text = { title: "SUSDOB", value: this.$moment(new Date(this.field_filters.sus_DOB.replace(/-/g, "/"))).format("MM/DD/YYYY") }
                    this.filters_active_text.push(filter_text)
                }

                if (this.field_filters.incident_date_start != "" || this.field_filters.incident_date_end != "") {

                    let sdate = "mm/dd/yyyy"
                    let edate = "mm/dd/yyyy"

                    if (this.field_filters.incident_date_start != "")
                        sdate = this.$moment(new Date(this.field_filters.incident_date_start.replace(/-/g, "/"))).format("MM/DD/YYYY");
                    if (this.field_filters.incident_date_end != "")
                        edate = this.$moment(new Date(this.field_filters.incident_date_end.replace(/-/g, "/"))).format("MM/DD/YYYY");


                    let filter_text = { title: "INCIDATE", value: sdate + " - " + edate }
                    this.filters_active_text.push(filter_text)
                }

                if (this.field_filters.modified_date_start != "" || this.field_filters.modified_date_end != "") {

                    let sdate = "mm/dd/yyyy"
                    let edate = "mm/dd/yyyy"

                    if (this.field_filters.modified_date_start != "")
                        sdate = this.$moment(new Date(this.field_filters.modified_date_start.replace(/-/g, "/"))).format("MM/DD/YYYY");
                    if (this.field_filters.modified_date_end != "")
                        edate = this.$moment(new Date(this.field_filters.modified_date_end.replace(/-/g, "/"))).format("MM/DD/YYYY");

                    let filter_text = { title: "LASTMODDATE", value: sdate + " - " + edate }
                    this.filters_active_text.push(filter_text)
                }

                if (this.field_filters.assigned_date_start != "" || this.field_filters.assigned_date_end != "") {

                    let sdate = "mm/dd/yyyy"
                    let edate = "mm/dd/yyyy"

                    if (this.field_filters.assigned_date_start != "")
                        sdate = this.$moment(new Date(this.field_filters.assigned_date_start.replace(/-/g, "/"))).format("MM/DD/YYYY");
                    if (this.field_filters.assigned_date_end != "")
                        edate = this.$moment(new Date(this.field_filters.assigned_date_end.replace(/-/g, "/"))).format("MM/DD/YYYY");

                    let filter_text = { title: "ASSIGNDATE", value: sdate + " - " + edate }
                    this.filters_active_text.push(filter_text)
                }

                if (this.field_filters.closed_date_start != "" || this.field_filters.closed_date_end != "") {

                    let sdate = "mm/dd/yyyy"
                    let edate = "mm/dd/yyyy"

                    if (this.field_filters.closed_date_start != "")
                        sdate = this.$moment(new Date(this.field_filters.closed_date_start.replace(/-/g, "/"))).format("MM/DD/YYYY");
                    if (this.field_filters.closed_date_end != "")
                        edate = this.$moment(new Date(this.field_filters.closed_date_end.replace(/-/g, "/"))).format("MM/DD/YYYY");

                    let filter_text = { title: "CLOSEDDATE", value: sdate + " - " + edate }
                    this.filters_active_text.push(filter_text)
                }

                this.$emit("filterTextUpdated", this.filters_active_text);
            },

            applyFilters() {
                this.dialog = false;
                setTimeout(() => {
                    this.$emit('applyFilters');
                }, 300)
            }

        },
        watch: {
            //Whenever object data changes emit new filter text
            field_filters: {
                handler(val) {
                    this.generate_filter_text();
                    if (this.$refs.form)
                        this.$refs.form.validate()
                },
                deep: true
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
    };
</script>
